import { User, Clock, Phone, Zap } from "lucide-react";
import { useContentCreatorKpiQuery } from "../../../reactWrapper/endpoints/talent/talent.api";
import { StatTile } from "../../../components/ui-x";

const intentLabels = {
  post_jobs: "Post Jobs",
  hire_freelancers: "Hire Freelancers",
  manage_teams: "Manage Teams",
};

/* NOTE: "Sales" and "Soon" both read the `waitlist` bucket in the original and
   that is preserved here verbatim — it looks like a data bug (contact_sales is
   never read) but changing it would alter what the screen reports. */
const BREAKDOWNS = [
  { label: "Now", type: "direct", icon: Zap },
  { label: "Sales", type: "waitlist", icon: Phone },
  { label: "Soon", type: "waitlist", icon: Clock },
];

export default function CreatorKPI({ userId }) {
  const { data } = useContentCreatorKpiQuery(userId ?? null);

  const kpis = data?.data?.kpis;
  const totalSignups = kpis?.total_signups ?? 0;

  const renderIntentList = (type) => {
    if (!kpis) return null;
    return (
      <div className="mt-3 divide-y">
        {Object.entries(intentLabels).map(([key, label]) => (
          <div
            key={key}
            className="flex items-center justify-between py-2 text-sm"
          >
            <span className="text-muted-foreground">{label}</span>
            <span className="font-semibold tabular-nums text-brand-navy">
              {kpis[key]?.[type] ?? 0}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <StatTile
        label="Total Leads"
        value={totalSignups}
        icon={<User className="h-4 w-4" />}
      />

      {BREAKDOWNS.map(({ label, type, icon: Icon }) => (
        <div
          key={label}
          className="rounded-2xl border bg-card p-5 shadow-ui-sm"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="text-sm font-medium text-muted-foreground">
              {label}
            </div>
            <div className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand-navy-100 text-brand-navy">
              <Icon className="h-4 w-4" />
            </div>
          </div>
          {renderIntentList(type)}
        </div>
      ))}
    </div>
  );
}
